import { connect } from 'react-redux'
import pick from './pick'
import mapDispatchers from './mapDispatchers'

const connectPropTypes = (Component) => {
	/* eslint-disable-next-line react/forbid-foreign-prop-types */
	const list = Object.keys(Component.propTypes)
	return connect(
		state => pick(state, list),
		dispatch => mapDispatchers(dispatch, list)
	)(Component)
}

export default connectPropTypes



// WEBPACK FOOTER //
// ./src/utilities/connectPropTypes.js